<template>
  <div class="topbar">
    <div class="left">
      <h1 class="wave">
        {{ $t("project_title") }}
      </h1>
      <p class="counts">
        <span class="up">
          &uarr;
        </span>
        <span class="day-count">
          {{cases.today}}
        </span>
        {{ $t("cases_last_day")}} (
        <span class="total-count">
          {{cases.total}}
        </span>
        total )
        <span class="up">
          &uarr;
        </span>
        <span class="day-count">
          {{deaths.today}}
        </span>
        {{ $t("deaths_last_day")}} (
        <span class="total-count">
          {{deaths.total}}
        </span>
        total)
      </p>
    </div>
    <div class="right">
      <div class="language">
        <LocaleChanger />
      </div>
      <div class="about">
        <button
          class="btn-invisible"
          id="show-modal"
          @click="showModal = true"
        >{{ $t("about") }}</button>
      </div>
      <div class="socials">
        <div class="twitter social">
          <a
            :href="'https://twitter.com/share?ref_src=twsrc%5Etfw&url=' + sharingUrl"
            target="_blank"
            rel="nofollow noreferrer"
          >
            <img
              src="../assets/twitter.svg"
              alt="twitter"
              class="social-image"
            >
          </a>
        </div>
        <div class="facebook social">
          <a
            :href="'https://www.facebook.com/sharer/sharer.php?u=' + sharingUrl + '%2F&amp;src=sdkpreparse'"
            target="_blank"
            rel="nofollow noreferrer"
          >
            <img
              src="../assets/fb.svg"
              alt="fb"
              class="social-image"
            ></a></div>
        <!-- <div class="share social"><a href="#">
            <img
              src="../assets/link.svg"
              alt="twitter"
              class="social-image"
            ></a></div> -->
      </div>
    </div>
    <AboutModal
      @close="showModal = false"
      :showModal="showModal"
    ></AboutModal>
  </div>
</template>

<script>
import LocaleChanger from "./LocaleChanger";
import AboutModal from "./AboutModal";

export default {
  data() {
    return {
      sharingUrl: "https%3A%2F%2Fcovidmap.hku.hk",
      showModal: false
    };
  },
  props: {
    deaths: Object,
    cases: Object
  },
  components: {
    LocaleChanger,
    AboutModal
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
a {
  color: #42b983;
}

.topbar {
  position: fixed;
  z-index: 1000;
  font-family: $type-normal;
  font-weight: 400;
  background: $hku-gray-2;
  height: 38px;
  max-height: 38px;
  min-height: 32px;
  width: 100%;
  color: $hku-offwhite;
  padding: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  vertical-align: middle;

  .left {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    h1.wave {
      font-size: 1em;
      font-weight: 500;
      margin: 0;
      margin-bottom: -2px;

      @media screen and (max-width: $breakpoint-tablet) {
        font-size: 0.85em;
      }
    }

    p.counts {
      margin: 0 0 0 4vw;
      font-size: 0.95em;
      .day-count {
        color: white;
        font-size: 1.2em;
        font-family: $type-number;
        font-weight: 600;
      }
      .up {
        font-weight: 800;
        font-size: 0.95em;
      }

      @media screen and (max-width: $breakpoint-wide) {
        display: none;
      }
    }
  }

  .right {
    display: flex;
    font-size: 0.95em;
    flex-direction: row;
    align-items: center;
    height: 100%;
    padding: 0;
    margin-bottom: -2px;

    .language,
    .about,
    .socials {
      margin: 0 4px;
      cursor: pointer;

      @media screen and (max-width: $breakpoint-tablet) {
        font-size:0.89em;
        margin: 0;
      }
      @media screen and (max-width: 330px) {
        font-size:0.85em;
      }
    }

    .socials {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 100%;
      .social {
        padding-left: 8px;
         @media screen and (max-width: $breakpoint-tablet) {
          padding-left:2px;
         }
        &.twitter {
          padding-left: 0;
        }
        img {
          height: 19px;
        }
      }
    }

    .about {
      text-transform: uppercase;
      font-weight: 600;

      button {
        font-family: $type-number;
        color: $hku-offwhite;
        transition: 0.1s linear;
        outline: 0;

        &:active,
        &:hover {
          color: white;
        }
      }
    }
  }
}
</style>
